import { render, staticRenderFns } from "./DeleteMaterial.vue?vue&type=template&id=43df914c&scoped=true&"
import script from "./DeleteMaterial.vue?vue&type=script&lang=js&"
export * from "./DeleteMaterial.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43df914c",
  null
  
)

export default component.exports